module.exports = __webpack_public_path__ + "img/read-img3.65a36203.png";